import React from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';
import { device } from "../device";

const Block = styled.div`
    border: 1px solid #EBAB0A;
    border-radius: 16px;
    display: flex;
    margin: ${({space}) => 
        (space === 'Top' && '48px 0 0') ||
        (space === 'TopDown' && '48px 0') || 
        (space === 'Down' && '0 0 48px') || 
        '0'
    };
    padding: 24px 16px;
    width: 100%;
    @media ${device.sm} {
        padding: 24px;
    }
    @media ${device.md} {
        padding: 24px 40px;
    }
`;
const Icon = styled.div`
    font-size: 0;
    height: 24px;
    flex: 0 0 24px;
    max-width: 24px;
    margin-top: 1px;
    margin-right: 16px;
    width: 24px;
`;
const Text = styled.div`
    align-self: center;
`;

function IdeaGeneral({ children, ...props }) {
    return (
        <Block space={props.space}>
            <Icon>
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M20.516 8.516c0 1.858-.62 3.639-1.626 5.033l-.077.077c-.155.232-.31.465-.542.697-1.084 1.316-3.174 4.18-3.174 6.58H8.903c0-2.4-2.09-5.264-3.174-6.58-.077-.116-.174-.232-.271-.349a4.233 4.233 0 01-.271-.348l-.077-.077a8.674 8.674 0 01-1.626-5.033A8.492 8.492 0 0112 0a8.492 8.492 0 018.516 8.516zM8.903 22.451h6.194V24H8.903V22.45z" fill="#EBAB0A"/></svg>
            </Icon>
            <Text>
                {children}
            </Text>
        </Block>
    )
}

IdeaGeneral.propTypes = {
    space: PropTypes.string
};

export default IdeaGeneral